import { firebaseDb } from '../firebase/'
export const loadBoards = () => (
  dispatch => {
    firebaseDb.collection('boards').onSnapshot(snapshot => (
      dispatch({
        type: 'LOAD_BOARDS',
        snapshot
      })
    ), err => {
      console.log('Encountered error', err);
    })
  }
)
export const changeCalendar = calendar => ({
  type: 'CHANGE_CALENDAR',
  calendar
})



// WEBPACK FOOTER //
// ./src/actions/home.js